module.exports = __webpack_public_path__ + "static/media/awards_8.33691c05.jpg";